import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { loadAndSetMockContext } from "@/utils/screen/mockContextLoader";

import "./index.css";

import { processTexts } from "./utils/helpers/processTexts.ts";
import App from "./App.tsx";

async function initializeApp() {
  await loadAndSetMockContext();

  // Process text templates in the universal login context before React mounts
  // This ensures all clientNames are replaced with "iFIT"
  // before any SDK instances are created or components render
  const clientName = window.universal_login_context?.client?.name;
  processTexts(window.universal_login_context?.screen?.texts, clientName);

  // Keep the document language aligned with Auth0 transaction locale.
  // This improves typography/line-breaking behavior for CJK languages in webviews.
  const locale = window.universal_login_context?.transaction?.locale || "en";
  document.documentElement.lang = locale;
  document.body.setAttribute("lang", locale);

  /**
   * ACUL Integration Note:
   * The following lines handle the specific way this React application is integrated
   * into Auth0's Universal Login page. Auth0 provides the base HTML DOM.
   * This script then creates a 'div' (rootElement),
   * appends it to Auth0's document.body, and then mounts the React application onto this div.
   * This differs from typical setups where an index.html is bundled directly with the app.
   */
  const rootElement = document.createElement("div");
  rootElement.id = "root";

  document.body.appendChild(rootElement);

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

initializeApp();
